import React from 'react'
import { Link } from '@inertiajs/react'
import { Inline } from '@/components/admin/atoms/layout/Inline'
import { Stack } from '@/components/admin/atoms/layout/Stack'
import { Heading } from '@/components/admin/atoms/typography/Heading'
import { Text } from '@/components/admin/atoms/typography/Text'
import { ActionButton } from '@/components/admin/atoms/actions/ActionButton'

interface PageAction {
  label: string
  href?: string
  onClick?: () => void
  icon?: React.ReactNode
}

interface PageHeaderProps {
  title: string
  description?: string
  action?: PageAction
  actions?: React.ReactNode
  className?: never
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title, description, action, actions,
}) => (
  <Inline justify="between" align="start">
    <Stack gap="1">
      <Heading level={2}>{title}</Heading>
      {description && <Text size="sm" color="muted">{description}</Text>}
    </Stack>

    <Inline gap="2">
      {actions}
      {action && (
        action.href ? (
          <Link href={action.href}>
            <ActionButton variant="primary">
              {action.icon && action.icon}
              {action.label}
            </ActionButton>
          </Link>
        ) : (
          <ActionButton variant="primary" onClick={action.onClick}>
            {action.icon && action.icon}
            {action.label}
          </ActionButton>
        )
      )}
    </Inline>
  </Inline>
)
